export enum CourseContentType {
  VIDEOS = 'VIDEOS',
  DAILY_NEWS = 'DAILY_NEWS',
  AUDIO_BYTES = 'AUDIO_BYTES',
  TEST_PREP = 'TEST_PREP',
  IDIOMS = 'IDIOMS',
  PRONUNCIATIONS = 'PRONUNCIATIONS',
  ISC = 'INDUSTRY_SPECIFIC_CONTENT'
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/course-content-type.ts